import React from 'react'

const Credits = () => {
    return (
        <div className="credits f-light">
            <div className="credits__develop">Desarrollado por <span className="credits__name">angel salvador</span></div>
            <span className="credits__copyright">Proyecto Digital © 2019 Derechos reservados</span>
        </div>
    )
}

export default Credits
